
























































































































































































































































































import {
  defineComponent,
  reactive,
  watch,
  ref,
  Ref,
} from "@vue/composition-api";
import { useUserServiceInject } from "@/context";

export interface TutorialEvent {
  initiator: string;
  receiver: string;
  type: string;
  initialSession: string;
  receivedTutorSession: string;
  remarks: string;
}

export default defineComponent({
  name: "EventView",
  data() {
    return {
      eventTypes: [
        { value: "REPLACE", text: "Ersetzen" },
        { value: "CANCEL", text: "Absagen" },
        { value: "EXCHANGE", text: "Tauschen" },
        { value: "DEFAULT", text: "Sonstiges" },
      ],
    };
  },
  methods: {
    getDateInWeek(week: any, weekday: any) {
      switch (weekday) {
        case "Mo":
          return week;
        case "Di":
          return this.addDays(new Date(week), 1);
        case "Mi":
          return this.addDays(new Date(week), 2);
        case "Do":
          return this.addDays(new Date(week), 3);
        case "Fr":
          return this.addDays(new Date(week), 4);
      }
    },
    addDays(date: any, days: any) {
      date.setDate(date.getDate() + days);
      const dateString = date.toISOString();
      const dateArray = dateString.split("T");
      return dateArray[0];
    },
    formatDate(d: any) {
      const dayParts = d.split("-");
      if (dayParts.length >= 3) {
        return dayParts[2] + "-" + dayParts[1] + "-" + dayParts[0];
      }
      return d;
    },
  },
  computed: {
    tutorItems() {
      const tutorItems: any[] = [];
      this.tutors.forEach((t) => {
        tutorItems.push({
          value: t.id,
          text: this.getName(t.id),
        });
      });
      return tutorItems;
    },
    tutorSessionItems() {
      const tutorSessionItems: any[] = [];
      this.myTutorSessions.forEach((s) => {
        tutorSessionItems.push({
          value: s.id,
          text:
            s.name + ", " + this.formatDate(this.getDateInWeek(s.group, s.day)),
        });
      });
      return tutorSessionItems;
    },
    exchangeTutorSessionItems() {
      const exchangeTutorSessionItems: any[] = [];
      this.exchangeSessions.forEach((s) => {
        exchangeTutorSessionItems.push({
          value: s.id,
          text:
            s.name + ", " + this.formatDate(this.getDateInWeek(s.group, s.day)),
        });
      });
      return exchangeTutorSessionItems;
    },
  },
  setup(props, { root }) {
    const { username, isStaff, isTutor } = useUserServiceInject();

    const event: TutorialEvent = reactive({
      initiator: username.value,
      receiver: "",
      type: root.$route.params.eventType ?? "",
      initialSession: "",
      receivedTutorSession: "",
      remarks: "",
    });

    const eventTutor = reactive({ value: root.$route.params.tutor ?? "" });
    const exchangeTutor = ref<string>("");
    const receiveTutorial = ref<number>(0);
    const myTutorSessions = ref<any[]>([]);
    const exchangeSessions = ref<any[]>([]);
    const tutors = ref<any[]>([]);

    const getExactDate = (group: string, day: string): Date => {
      const weekList = ["Mo", "Di", "Mi", "Do", "Fr"];
      const date = new Date(group);
      date.setDate(date.getDate() + weekList.indexOf(day));
      return date;
    };

    const pushSessionsToList = (sessions: any, to: Ref<any[]>) => {
      sessions
        .filter((session: any) => {
          const group = session["group"];
          const day = session["day"];
          return (
            new Date(new Date().toDateString()) <= getExactDate(group, day) &&
            session["status"] !== "CANCELED"
          );
        })
        .forEach((elem: any) => to.value.push(elem));
    };

    if (root.$route.params.id && root.$route.params.tutor) {
      async () => {
        const reponse = await root.$axios.get(
          "tutor_sessions/get_tutor_username/",
          {
            params: { tutor: root.$route.params.tutor },
          }
        );
        pushSessionsToList(reponse, myTutorSessions);
      };
    }

    root.$axios.get("tutors/get_name_id/").then((response) => {
      response.data.forEach((elem: any) => tutors.value.push(elem));
      if (!isStaff.value) {
        eventTutor.value = (tutors.value.find(
          (tutor) => tutor["username"] == username.value
        ) ?? { id: "" })["id"];
      }
    });

    const getSessionRepresent = (
      name: string,
      group: string,
      day: string
    ): string => {
      let dateString = "";
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      } as const;
      const date = getExactDate(group, day);
      dateString = date.toLocaleDateString("de-DE", options);

      return name ? name + " " + dateString : "";
    };

    const getName = (id: string) => {
      const tutor: any = tutors.value.find((tutor) => tutor["id"] == id);

      if (tutor["firstName"] || tutor["lastName"]) {
        return `${tutor["firstName"] ?? ""} ${tutor["lastName"] ?? ""}`;
      }

      if (tutor["username"]) {
        return tutor["username"] ?? "";
      }

      return "";
    };

    const sendEvent = () => {
      //Validation
      switch (event.type) {
        case "CANCEL":
          if (!eventTutor || !event.initialSession) {
            alert(root.$t("events.warning.cancelSession").toString());
            return;
          }
          break;
        case "REPLACE":
          if (!eventTutor || !event.initialSession) {
            alert(root.$t("events.warning.replaceSession").toString());
            return;
          }
          if (!event.receiver) {
            alert(root.$t("events.warning.replaceTutor").toString());
            return;
          }
          break;
        case "EXCHANGE":
          if (!eventTutor || !event.initialSession) {
            alert(root.$t("events.warning.exchangeSession").toString());
            return;
          }
          if (!event.receivedTutorSession) {
            alert(root.$t("events.warning.exchangeSessionReceive").toString());
            return;
          }
          break;
        case "DEFAULT":
          if (!eventTutor || !event.initialSession) {
            alert(root.$t("events.warning.remarkSession").toString());
            return;
          }
          if (!event.remarks) {
            alert(root.$t("events.warning.remark").toString());
            return;
          }
          break;
        default:
          alert(root.$t("events.warning.type").toString());
      }

      root.$axios
        .post("events/", {
          initiator: event.initiator,
          receiver: event.receiver,
          type: event.type,
          // eslint-disable-next-line @typescript-eslint/camelcase
          initial_session: event.initialSession,
          // eslint-disable-next-line @typescript-eslint/camelcase
          receiving_session: event.receivedTutorSession,
          remarks: event.remarks,
        })
        .then((req) => {
          if (req.status == 201) {
            alert(root.$t("events.warning.success"));
            root.$router.push({ name: "tutorials" });
          } else {
            alert(root.$t("events.warning.fail"));
          }
        });
    };

    watch(exchangeTutor, (val: string) => {
      root.$axios
        .get("tutor_sessions/get_tutor_username/", {
          params: {
            tutor: val,
          },
        })
        .then((req) => {
          exchangeSessions.value = [];
          pushSessionsToList(req.data, exchangeSessions);
        });
    });

    watch(
      () => eventTutor.value,
      (val: string) => {
        root.$axios
          .get("tutor_sessions/get_tutor_username/", {
            params: {
              tutor: val,
            },
          })
          .then((req) => {
            myTutorSessions.value = [];
            pushSessionsToList(req.data, myTutorSessions);
          });
      }
    );

    return {
      // attrs
      isStaff,
      isTutor,
      event,
      eventTutor,
      receiveTutorial,
      myTutorSessions,
      exchangeSessions,
      tutors,
      exchangeTutor,

      // functions
      getExactDate,
      getSessionRepresent,
      getName,
      sendEvent,
    };
  },
});
